/* eslint-disable no-restricted-imports */
/* eslint-disable complexity */
import { FC, Fragment } from 'react';
import { AuthFlowAction } from '@/components/blocks/AuthentificationFlow';
import { ModalLogin } from '@/components/blocks/ModalLogin/Index';
import { ModalRegister } from '@/components/blocks/ModalRegister';
import { RegistrationOrigin } from '@/data/Content/Registration';

type AuthFlowModalProps = {
	action: AuthFlowAction;
	onClose: () => void;
	onGo: (action: AuthFlowAction) => void;
	type?: 'login' | 'wishlist' | 'dp-fan';
	origin?: RegistrationOrigin;
	onAuthSuccess?: () => void;
};

export const AuthFlowModal: FC<AuthFlowModalProps> = ({
	action,
	type,
	origin,
	onAuthSuccess,
	onGo,
	onClose,
}) => (
	<Fragment>
		{AuthFlowAction.LOGIN === action ? (
			<ModalLogin
				type={type}
				origin={origin}
				onAuthSuccess={onAuthSuccess}
				onClose={onClose}
				onGoRegister={() => onGo(AuthFlowAction.REGISTER)}
			/>
		) : (
			<ModalRegister
				origin={origin}
				onClose={onClose}
				onGoBack={() => onGo(AuthFlowAction.LOGIN)}
				onAuthSuccess={onAuthSuccess}
			/>
		)}
	</Fragment>
);
